import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../utils/getCropppedImg";
import { Button, DialogActions, DialogContent } from "@mui/material";
import "./PhotoAdjuster.css";
import { useTranslation } from "react-i18next";
const PhotoAdjuster = ({ image, onSave, onReturn }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedPixels, setCroppedPixels] = useState(null);
  const { t } = useTranslation();
  const onCropComplete = useCallback((_, areaPixels) => {
    setCroppedPixels(areaPixels);
  }, []);

  const handleSave = async () => {
    if (!croppedPixels) return;

    const result = await getCroppedImg(image, croppedPixels);
    onSave(result.file, result.preview);
  };
  if (!image) return null;
  return (
    <>
      <DialogContent>
        {/* CROP AREA */}
        <div
          style={{
            width: "100%",
            height: "300px",
            position: "relative",
            border: "1px solid #ccc",
            borderRadius: 8,
            overflow: "hidden",
            marginBottom: 20,
            borderRadius: "16px",
          }}
        >
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            minZoom={0.5}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            restrictPosition={false}
            cropSize={{ width: 200, height: 200 }}
          />
        </div>

        {/* SLIDER */}
        <div className="slider-section" >
          <div className="slider-labels">
            <div className="slider-label-first">
              <span className="material-symbols-outlined zoom-icon-slider">
                zoom_in
              </span>
              <span className="zoom-text-slider">Zoom</span>
            </div>
            <span className="zoom-text-slider">100%</span>
          </div>
          <input
            type="range"
            min={0.5}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(e.target.value)}
            className="custom-slider" />
          <span className="zoom-slider-instruction">
            {t("adjut_photo_instructions")}
          </span>
        </div>
      </DialogContent>

      <DialogActions sx={{
        marginTop: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
      }}>
        <Button
          sx={{
            display: "flex",
            padding: "11px 22px",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "8px",
            color: "#0C0C0C",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            textTransform: "none",
          }}
          onClick={() => {
            onReturn();
          }}>
          <span className="material-symbols-outlined">
            photo_camera
          </span>
          {t("retake_photo")}
        </Button>
        <Button
          sx={{
            display: "flex",
            padding: "11px 22px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            background: "#60D744",
            borderRadius: "8px",
            color: "#0C0C0C",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            textTransform: "none",
          }}
          onClick={() => {
            handleSave();
          }}>
          {t("use_photo")}
        </Button>
      </DialogActions>
    </>
  );
};

export default PhotoAdjuster;